import { ListItemBaseProps } from "@mui/material/ListItem"

import { KeyboardArrowRightIcon } from "@l2r-front/l2r-icons"
import { Typography } from "@l2r-front/l2r-ui"

import * as Styled from "./MobileAccountSettingsMenuItem.styled"

type MobileAccountSettingsMenuItemProps = ListItemBaseProps & {
    label: string
    desc?: string
    icon?: React.ReactNode
    onClick?: () => void
    variant?: "primary" | "secondary"
    showArrow?: boolean
    badgeCount: number
}

export const MobileAccountSettingsMenuItem = (props: MobileAccountSettingsMenuItemProps) => {

    const {
        label,
        desc,
        icon,
        onClick,
        variant = "primary",
        showArrow = true,
        badgeCount,
        ...listItemProps
    } = props

    const ContainerComponent = onClick ? Styled.ListItemButton : Styled.ListItemContainer

    return (
        <ContainerComponent {...listItemProps} onClick={onClick}>
            {icon && <Styled.IconWrapper>
                {icon}
            </Styled.IconWrapper>}
            <Styled.ListItem variant={variant}>
                <Styled.ListItemHeader>
                    <Styled.PrimaryTypography id="accountSettings-label" variant="Desktop & Mobile/Body/Regular">
                        {label}
                    </Styled.PrimaryTypography>
                </Styled.ListItemHeader>
                {desc && <Styled.SecondaryTypography
                    id="accountSettings-desc"
                    variant="Desktop & Mobile/Body/Small"
                    textColor={variant === "primary" ? "text/secondary" : "text/tertiary"}>
                    {desc}
                </Styled.SecondaryTypography>}
            </Styled.ListItem>
            {badgeCount && <Styled.Badge>
                <Typography variant="Desktop & Mobile/Body/Label & Helper text">{badgeCount}</Typography>
            </Styled.Badge>
            }
            {showArrow && <KeyboardArrowRightIcon color="common/black_states" />}
        </ContainerComponent >
    )
}
